import React from 'react'
import { observer } from 'mobx-react-lite'

import { LoadOrdersForm } from './LoadOrdersForm'

import { useApi } from '../hooks/storeHook'
import { OzonAccountProps } from '../types/accountProps'

export const OzonLoadOrdersForm =
  observer(
    ({account}: OzonAccountProps) => {
      const api = useApi()

      return <LoadOrdersForm accountId={account.id} loadOrders={api.userSync.loadOzonOrders}/>
    })